import {
	GET_SALES_PASSENGERS,
	GET_SALES_PASSENGERS_SUCCESS,
	GET_SALES_PASSENGERS_ERROR,
	GET_PROGRAMS,
	GET_PROGRAMS_SUCCESS,
	GET_PROGRAMS_ERROR
} from "../../shared/constants";

const iniCancellation = {
	fetchingSales: true,
	totalValue: 0,
	sales: [],
	logs: [],
	errorSales: false,
	fetchingPrograms: false,
	totalPassengers: 0,
	programs: [
		{
			id: 3,
			name: "Multiplus"
		},
		{
			id: 6,
			name: "Amigo"
		},
		{
			id: 4,
			name: "Smiles"
		},
		{
			id: 5,
			name: "Tudo Azul"
		}
	],
	errorPrograms: false
};

export const salespassengers = (state = iniCancellation, { payload, type }) => {
	switch (type) {
		case GET_SALES_PASSENGERS:
			return {
				...state,
				fetchingSales: true,
				errorSales: false,
				sales: [],
				logs: [],
				totalValue: 0,
				totalPassengers: 0
			};
		case GET_SALES_PASSENGERS_SUCCESS:
			return {
				...state,
				sales: payload.report,
				logs: payload.logs,
				totalValue: payload.totalValue,
				totalPassengers: parseInt(payload.totalPassengers),
				fetchingSales: false,
				errorSales: false
			};
		case GET_SALES_PASSENGERS_ERROR:
			return {
				...state,
				sales: [],
				logs: [],
				errorSales: payload,
				fetchingSales: false,
				totalValue: 0,
				totalPassengers: 0
			};
		case GET_PROGRAMS:
			return {
				...state,
				fetchingPrograms: true,
				errorPrograms: false
			};
		case GET_PROGRAMS_SUCCESS:
			return {
				...state,
				programs: payload,
				fetchingPrograms: false,
				errorPrograms: false
			};
		case GET_PROGRAMS_ERROR:
			return {
				...state,
				errorPrograms: payload,
				fetchingPrograms: false
			};
		default:
			return state;
	}
};
